import { Injectable, Pipe, PipeTransform } from '@angular/core';

// Strips HTML tags from the given input
// To strip all tags, use ` | removeHTMLTags`
// To strip all tags but the default ones, use ` | removeHTMLTags:true`
// To strip only selected tags, use ` | removeHTMLTags:'strong|br'`
@Pipe({
  name: 'rtRemoveHTMLTags',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class RemoveHTMLTagsPipe implements PipeTransform {
  private readonly defaultExcludedTags: string[] = ['strong', 'em', 'span', 'br', 's'];

  public transform(value: string, excludedTags?: true | string | string[]): string {
    if (typeof value === 'string') {
      if (excludedTags) {
        const tags = excludedTags === true ? this.defaultExcludedTags : excludedTags;
        const regexp = this.getExcludedTagsRegexp(tags);
        const excludedRegexp = new RegExp(regexp, 'ig');
        return value.replace(excludedRegexp, '');
      } else {
        return value.replace(/(<([^>]+)>)/gi, '');
      }
    } else {
      return '';
    }
  }

  private getExcludedTagsRegexp(excludedTags: string | string[]): string {
    const excludedString = Array.isArray(excludedTags) ? excludedTags.join('|') : excludedTags;
    return `<(?!${excludedString})(?!\/(${excludedString})).[^<>]*?\>`;
  }
}
